import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { GameService } from '../services/game.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Game, Round, Question } from '../classes/Game';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { InGameOptionsComponent } from '../modals/in-game-options/in-game-options.component';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component';


@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
  animations: [
    trigger('slideInFromRight', [
      state('hide', style({ transform: 'translateX(0)' })),
      state('show', style({ transform: 'translateX(-100%)' })),
      transition('* => *', animate(200))
    ]),
    trigger('slideInFromLeft', [
      state('hide', style({ transform: 'translateX(0)' })),
      state('show', style({ transform: 'translateX(100%)' })),
      transition('* => *', animate(200))
    ]),
    trigger('slideInFromBottom', [
      state('hide', style({transform: 'translateY(0)'})),
      state('show', style({transform: 'translateY(-100vh)'})),
      transition('* => *', animate(200))
    ])
  ]
})
export class GameComponent implements OnInit {
  game_id: string;
  game: Game;
  // round_index: number;
  menuPosition = 'hide';
  imgMenuPosition = 'hide';
  teamListPosition = 'hide';
  //doubleOrNothing = false;

  ws: WebSocket;
  wsAttempts = 0;
  deadWS: boolean = null;

  err = "";
  invErr = "";

  inviteFromTeam: string = "";

  confirmSub: boolean;
  tipQM: boolean;

  isLoggedIn: boolean;

  captainMsg = ""

  showImgUpload: boolean;
  didSSPreview: boolean;

  refreshButtonLink: string | null = null;

  heartbeat;

  lastMessage: string = "";

  messageLog: string[] = [];

  constructor(
    private acitvatedRoute: ActivatedRoute,
    private router: Router,
    private gameService: GameService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.acitvatedRoute.params
    .subscribe( (params: any) => {
      this.game_id = params.id;
      this.connectWS();
      this.setVisibilityListener();
    });
    this.isLoggedIn = this.authService.getToken() ? true : false;
    this.checkPreviewed();

    this.refreshButtonLink = null;

    // this.showGameOptions();
  }

  ngOnDestroy() {
    this.deadWS = true;
    console.log("closing connection", this.ws);
    this.ws.close();
    clearInterval(this.heartbeat)
  }

  /**
   * Only show if the user hasn't clicked one of the options.
   */
  // showGameOptions(){
  //   const userJoinStatus = localStorage.getItem('join_status');
  //   if(["joined","spectator"].indexOf( userJoinStatus) == -1 ){
  //     const dialogRef = this.dialog.open(InGameOptionsComponent,{
  //       data: {onWatch: () => this.spectatorMode(), onJoin: ()=> this.joinTeam()},
  //       disableClose: true
  //     });
  //   }
  // }

  spectatorMode(){
    sessionStorage.setItem(`choseSpectator`, "true");
    this.dialog.closeAll();
  }

  joinTeam(){
    this.dialog.closeAll();
    this.toggleMenu('teamListPosition');
  }

  get joinStatus(){
    return localStorage.getItem('join_status');
  }

  getCounterSlug() {
	let player = this.authService.getPlayer()
	let pid = player ? `${player.playerid}-` : '';
	let dt = new Date();
	return `${pid}res-${dt.getUTCFullYear()}-${dt.getUTCMonth() + 1}-${dt.getUTCDate()}`;
  }

  checkPreviewed() {
	let key = `${this.getCounterSlug()}-previewed`
	let previewed = localStorage.getItem(key);
	this.didSSPreview = previewed ? true : false;
	console.log(this.didSSPreview)
  }

  registrationPrompt() {
  	if (this.isLoggedIn && this.game.me.status === 'joined' && this.game?.my_team) {
  		if (!this.game.my_team.kt_team_id) {
  			return sessionStorage.getItem('dismissed_team_register') ? false : true
  		}
  	}
  	return false
  }

  setVisibilityListener() {
    document.addEventListener('visibilitychange', (event) => {
      console.log(document.visibilityState);
      if (document.visibilityState === 'visible') {
        if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
          this.connectWS();
        }
      }
    })
  }

  toAuth(success: string = "") {
  	let params: any = {previous: window.location.pathname};
    if (success) params['success'] = success;
  	this.router.navigate(['/auth'], {queryParams: params});
  }

  showTeamList() {
    this.teamListPosition = "show";
  }

  removeAutoJoin() {
    this.inviteFromTeam = "";
  }

  loadGame() {
    this.gameService.loadGame(this.game_id)
      .subscribe( (game: any) => {
        if (!this.deadWS) {
          this.err = "";
          this.invErr = ""
        }
        this.game = new Game(game);
        this.restoreAnswers();
        if (this.registrationPrompt()) this.toggleMenu()
        else if (this.game.me?.status !== 'joined' && !(sessionStorage.getItem('choseSpectator'))) {
          this.teamListPosition = 'show';
        }
        console.log('set game:', this.game);
      },
      err => {
        let modalTitle;
        let modalBody;
        let modalButtonLabel;
        if (err.error?.status_code === 403) {
          modalTitle = "No Game Access";
          modalBody = "You may not have joined this game yet. Ask your QM for the join code to get started!";
          modalButtonLabel = "Enter Join Code";
        }
        else if (err.error?.status_code === 404) {
          modalTitle = "Game Not Found";
          body: "This game does not exist";
          modalButtonLabel: "Back To Home"
        }
        if (modalTitle) {
          const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            data: {
              title: modalTitle,
              body: modalBody,
              confirmButtonLabel: modalButtonLabel,
              onConfirm: () => {
                dialogRef.close();
                this.router.navigate["/"];
              }
            },
            disableClose: true
          })
        }
        else this.err = err.error.detail;
      });
  }

  resetConnection() {
    if( !this.refreshButtonLink ){
      this.deadWS = null;
      this.wsAttempts = 0;
      this.err = "Attempting to connect...";
      this.connectWS();
    }else{
      this.router.navigate([this.refreshButtonLink]);
    }
  }

  resetHeartbeat() {
    if (this.heartbeat) clearInterval(this.heartbeat);
    this.heartbeat = setInterval(this.sendHeartbeat.bind(this), 60000);
  }

  sendHeartbeat() {
    if (this.ws) {
      this.ws.send(`thump thump|${this.lastMessage}`);
    }
    else console.log("No Websocket available for sending heartbeat")
  }

  acknowledgeMsg(msg_id: string) {
    if (this.ws) {
      if (!this.messageLog.includes(msg_id)) {
        this.messageLog.push(msg_id)
        if (this.messageLog.length > 15) this.messageLog.shift()
      }
      this.ws.send(`acknowledge|${msg_id}`)
    }
    else console.log("No websocket available for sending acknowledgement")
  }

  async connectWS(): Promise<void> {
      if (this.ws) {
        this.ws.close();
      }
      
      this.messageLog = [];

      try {
        let g = await this.gameService.loadGame(this.game_id).toPromise();
        if (!g) throw new Error("Game not found!")
        let host = (!environment.host) ? window.location.host : environment.host;
        let client_id = localStorage.getItem('kt_client_id');
        if (!client_id) throw new Error("Client ID was not set!");
        let token = localStorage.getItem('auth_token');
        let ws_endpoint = `${environment.ws.protocol}://${host}/api/game/ws/${this.game_id}`;
        if (g?.team !== null) ws_endpoint = `${ws_endpoint}/player/${client_id}/${g.team.team_code}`;
        else ws_endpoint = `${ws_endpoint}/watcher/${client_id}/${g.me.player_code}`;
        if(token) ws_endpoint = `${ws_endpoint}?token=${token}`;
        
        this.ws = new WebSocket(ws_endpoint);
      }
      catch (e) {
        this.err = `Unable to initialize game: ${e}`;
        this.deadWS = true;
        return;
      }

      this.ws.onerror = (event) => {
        if (document.visibilityState === "visible") {
          this.err = "Attempting to connect...";
          console.log('WS error:', event);
          if (this.wsAttempts < 4) {
            this.wsAttempts++;
            this.connectWS();
          }
          else {
            this.err = "Connection Interrupted";
            this.deadWS = true;
          }
        }
      };

      this.ws.onclose = (event) => {
        if (this.deadWS === null && document.visibilityState === "visible") {
          this.deadWS = false;
          this.ws.onerror(event);
        }
      }

      this.ws.onopen = (event) => {
        try {
          const token = this.authService.getToken();
          // const data = {type: 'JOIN', token, client_id: localStorage.getItem('kt_client_id')};
          this.loadGame();
          // this.ws.send(JSON.stringify(data));
          this.resetHeartbeat();
          this.refreshButtonLink = "";
          this.err = "";
          this.deadWS = null;
          console.log('WS opened:', event);
        }
        catch (e) {
          this.deadWS = true;
          this.err = `Error connecting to game: ${e}`;
          this.ws.close()
        }
      };

      this.ws.onmessage = (event) => {
        try {
          let msg = JSON.parse(event.data);
          let data: any = {};
          if( msg.hasOwnProperty('data') ){
            data = JSON.parse(msg.data);
          }
          console.log('WS Data:', data);
          this.refreshButtonLink = null;
          if (!this.messageLog.includes(msg.msg_id)) {
            this.resetHeartbeat()
            if (this.messageLog.length === 0 || msg.msg_id > this.lastMessage) {
              this.messageLog.push(msg.msg_id);
              this.lastMessage = msg.msg_id;
              switch (data.type) {

                case 'WEBSOCKET_ERROR':
                  console.log("[I] WEBSOCKET ERROR");
                  this.deadWS = true;
                  this.wsAttempts = 5;
                  this.err = "Connection Interrupted";
                  this.ws.close();
                  break;

                case 'NO_GAME_ACCESS':
                  console.log("[I] NO GAME ACCESS");
                  this.deadWS = true;
                  this.wsAttempts = 5;
                  this.err = data.error ?? "Server refused access.";
                  this.refreshButtonLink = "/";
                  this.ws.close();
                  break;

                case 'ASK':
                  this.game.processAskedList(data.questions);
                  this.game.game_started = true;
                  if (data.open_submissions) this.game.submissions_open = true;
                  break;

                case 'RECALL': // un-ask a question
                  this.game.round.recallQuestion(data.question_id)
                  break;

                case 'SUBMIT_ANSWER':
                  this.game.round.submitted = true;
                  let submission = {
                    doubled: data.doubled,
                    answers: data.answered,
                    single_answer: data.single_answer,
                    title: data.title,
                    round_id: data.round_id
                  }
                  this.game.submitted[data.round_order] = submission;
                  console.log(this.game.submitted);
                  break;

                case 'SET_DOUBLE':
                  this.game.round.doubled = data.doubled;
                  break;

                case 'ROUND_START': // start round
                  this.checkPreviewed();
                  if (data.restart) {
                    this.loadGame();
                    break;
                  }
                  if (this.game.round_index !== data.round_index) {
                    this.game.round_index = data.round_index;
                    this.game.round = new Round(data.round);
                  }
                  break;

                case 'ROUND_END': // end round
                  this.game.round = null;
                  this.game.round_index = null;
                  // this.doubleOrNothing = false;
                  break;

                case 'SUGGEST':
                  delete data.type;
                  this.game.suggested = data;
                  for (const key of Object.keys(this.game.suggested)) {
                    this.game.round.questions[key].suggestions = this.game.suggested[key];
                  }
                  this.cdr.markForCheck();
                  break;

                case 'DROP_PLAYER':
                  const reason: string = data?.reason;
                  if (data.player.player_code === this.game.me.player_code) {
                    if(reason.includes("kicked")){
                      let dialogRef = this.dialog.open(ConfirmationModalComponent, {
                        data: {
                          title: "You Have been dropped from the team",
                          body: "",
                          confirmButtonLabel: 'Okay',
                          onConfirm: () => {
                            dialogRef.close();
                            window.location.reload();
                          }
                        },
                        disableClose: true
                      });
                    }
                    else window.location.reload();
                  }else{
                    /// Notify Team members
                    this.game.removePlayerWithCode(data.player.player_code);
                    if(reason.includes("left")){
                      let dialogRef = this.dialog.open(ConfirmationModalComponent, {
                        data: {
                          title: data?.player?.player_name + ' has been dropped from the team',
                          body: "",
                          cancelButtonLabel: 'Close',
                          confirmButtonLabel: 'Okay',
                          onCancel: ()=> dialogRef.close(),
                          onConfirm: ()=> dialogRef.close()
                        }
                      });
                    }
                  }
                  if(data?.player.is_captain === true){
                    this.loadGame();
                  }
                  break;

                case 'PLAYER_JOIN':
                  const player = { ...data.player };
                  let found = this.game?.my_team?.players?.find(p => p.player_code === player.player_code);
                  if (!found) {
                    found = this.game?.my_team?.players?.find(p => p.email === player.email || p.phone === player.phone);
                    if (found) {
                      found.player_name = player.player_name;
                      found.playerid = player.playerid;
                      found.player_code = player.player_code;
                      found.profile_img = player.profile_img;
                      found.client_id = player.client_id;
                      found.is_captain = player.is_captain;
                    }
                    else this.game?.my_team?.players?.push(player);
                  } else {
                    found.player_name = player.player_name;
                    found.playerid = player.playerid;
                    found.client_id = player.client_id;
                    found.is_captain = player.is_captain;
                  }
                  break;

                case 'REGISTER_TEAM':
                  if (this.game.my_team?.team_code === data.team_code) {
                    this.game.my_team.kt_team_id = data.kt_team_id;
                  }
                  for (let t of this.game.game_teams) {
                    if (t.team_code === data.team_code) {
                      t.kt_team_id = data.kt_team_id;
                    }
                  }
                  break;

                case 'NEW_TEAM':
                  const nt = data.team;
                  this.game.addTeam(nt)
                  break; 

                case 'NEW_TEAM_NAME':
                  this.game.renameTeam(data.team_code, data.team_name);
                  break;            

                case 'KICK_TEAM':
                  this.game.removeTeam(data.team_code);
                  if (data.team_code === this.game.my_team?.team_code) {
                    let dialogRef = this.dialog.open(ConfirmationModalComponent,
                      {data: {
                        title: `${this.game.my_team.team_name} has been Kicked!`,
                        confirmButtonLabel: "Okay",
                        onConfirm: () => {
                          if (this.game.me.status === "joined") this.router.navigate(['/']);
                          else {
                            this.game.my_team = null;
                            this.game.me.status = "watching";
                          }
                          dialogRef.close();
                        }
                      },
                      disableClose: true
                    })
                  }
                  break;

                case 'PROMOTE_CAPTAIN':
                  this.captainMsg = "";
                  this.game.me.is_captain = (data.player_code === this.game?.me?.player_code)
                  this.game.my_team.players = this.game?.my_team?.players.map(x => {
                      if (x.player_code === data.player_code) {
                        x.is_captain = true;
                        this.captainMsg = this.game.me.is_captain ? "You" : x.player_name;
                      }
                      else x.is_captain = false;
                      return x;
                    });
                  break;

                case 'OPEN_SUBMISSIONS':
                  this.game.processAskedList(data.asked);
                  this.game.submissions_open = true;
                  break;

                case 'CLOSE_SUBMISSIONS':
                  this.game.submissions_open = false;
                  if (!data.keep_round) {
                    this.game.round_index = null;
                    this.game.round = null;
                  }
                  break;

                case 'RESET_SUBMISSION':
                  if (data.team_code === this.game?.my_team?.team_code) {
                    if (this.game.round) this.game.round.submitted = false;
                    for (let i = 0; i < this.game.submitted.length; i++) {
                      let s = this.game.submitted[i];
                      if (s && s.round_id === data.round_id) {
                        this.game.submitted[i] = undefined;
                        break;
                      }
                    }
                  }
                  break;

                case 'TEAM_SUBMITTED':
                  if (data.team_code === this.game?.my_team?.team_code) {
                    this.game.round.submitted = true;
                  }
                  break;

                case 'CAPTAIN_SUGGEST':
                  if (!this.game?.me?.is_captain) {

                  }
                  break;

                case 'PLAYER_INVITE':
                  if (this.game.me.playerid) {
                    let my_invite;
                    if (data.email && data.email === this.game.me.email) my_invite = true;
                    else if (data.phone && data.phone === this.game.me.phone) my_invite = true;
                    if (my_invite) {
                      this.game.addInviteForPlayer(data);
                    }
                    if (!this.game.my_team) {
                      let dialogRef = this.dialog.open(ConfirmationModalComponent,
                        {data: {
                          title: `You Have Recieved an invitation!`,
                          body: `${data.inviter_name} has invited to join ${data.team_name}`,
                          cancelButtonLabel: 'Ignore',
                          confirmButtonLabel: 'Accept',
                          onCancel: ()=> dialogRef.close(),
                          onConfirm: () => {
                              this.menuPosition = 'hide';
                              this.imgMenuPosition = 'hide';
                              this.teamListPosition = 'hide';
                              this.inviteFromTeam = data.team_code;
                              setTimeout(this.showTeamList.bind(this), 200);
                              setTimeout(this.removeAutoJoin.bind(this), 800);
                              dialogRef.close();
                            }
                          }
                        }
                      );
                    }
                    else {
                      this.game.addInvitedPlayer(data);
                    }
                  }
                  break;

                case 'CANCEL_INVITE':
                  if (this.game.me.playerid) this.game.removeInviteForPlayer(data.team);
                  if (this.game.my_team) this.game.removeInvitedPlayer(data);
                  console.log(this.game.invites);
                  break;

                case 'END_GAME':
                  this.game.status = 'ended';
                  break;

                case 'RELOAD_GAME':
                  this.game.status = 'live';
                  break;
                
                case 'PLAYER_PENDING_TEAM_JOIN':
                  const p = data.player;
                  if( p.player_code !== this.game.me.player_code && p.team_code === this.game.my_team.team_code){
                    this.game?.my_team?.players.push(p)
                    let dialogRef = this.dialog.open(ConfirmationModalComponent,
                      {data: {
                        title: `Join Request from ${p.player_name}`,
                        body: "You can approve or decline their request on the team management page.",
                        cancelButtonLabel: 'Close',
                        confirmButtonLabel: 'View',
                        onCancel: ()=> dialogRef.close(),
                        onConfirm: () => {
                          if(this.menuPosition === 'hide'){
                            this.toggleMenu();
                          }
                          dialogRef.close();
                        }
                      }
                    });
                  }
                  break;

                case 'PLAYER_DECLINED_TEAM_JOIN':                
                  if( data?.player?.player_code === this.game.me.player_code ){
                    let dialogRef = this.dialog.open(ConfirmationModalComponent, {
                      data: {
                        title: 'Request Declined',
                        body: `Your Join Request was declined by the team captain.`,
                        confirmButtonLabel: 'Okay',
                        onConfirm: () => {
                          this.game.my_team = null;
                          this.game.me.status = "watching";
                          dialogRef.close()
                        }
                      },
                      disableClose: true
                    });
                  }
                  else this.game.removePlayerWithCode(data?.player?.player_code);
                  break;
                
                case 'PLAYER_APPROVED_TEAM_JOIN':
                  if(data?.player.player_code === this.game.me.player_code){
                    window.location.reload();
                  }
                  else if(this.game.my_team?.team_code === data?.player?.team_code){
                    this.game.acceptJoiningPlayer(data.player);
                  }
                  break;
                
                case 'PLAYER_CANCEL_TEAM_JOIN':
                  if (data?.player?.player_code === this.game.me.player_code) {
                    this.game.me.status = "watching";
                    this.game.me.team_code = "";
                  }
                  else if( data?.player?.team_code === this.game?.my_team?.team_code ){
                    this.game.removePlayerWithCode(data.player.player_code);
                  }
                  break;
              }
            }
            else {
              console.log(`Message ${msg.msg_id} is older than the most recent message: ${this.lastMessage}`)
              this.err = "Refreshing Connection...";
              this.connectWS();
              return;
            }
          }
          this.acknowledgeMsg(msg.msg_id) 
        }
        catch (e) {
          this.err = "Something went Wrong... Refreshing Connection";
          console.log(e);
          this.connectWS();
          return;
        }
      };
          
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  submitRound(): void {
    this.err = "";
    const answers = [];
    const r_idx = this.game.round_index;
    this.confirmSub = false;
    let q_count = 1;
    for (const q of this.game?.round?.questions) {
      let q_answers = [];
      for (let a of q.answers) {
        a = a.toLowerCase();
        for (let ua of q_answers) {
          if (ua === a) a = "";
        }
        if (this.game.round.single_answer) {
          if (q_count < this.game.round.questions.length) {
            a = "";
          }
        }
        q_answers.push(a);
      }
      answers.push(q_answers);
      q_count++;
    }

    this.gameService.submitRound(this.game_id, r_idx, answers, this.game.round.doubled)
    .subscribe(
      result => {
        console.log('submit round:', result);
        this.game.round.submitted = true;
      },
      err => {
        console.log('submit round error:', err);
        this.err = "Something went wrong... Please try again.";
        this.game.round.submitted = false;
      });
  }

  changedAnswer(question: any, q_idx: number, a_idx: number, value: string): void {
    console.log('changedAnswer', value);
    question.answers[a_idx] = value;

    this.backupAnswers();

    // if (!this.game.me.is_captain) {
    //   this.gameService.suggestAnswer(this.game_id, this.game.round_index, q_idx, value)
    //   .subscribe( (result: any) => {

    //   });
    // }
  }

  backupAnswers() {
  	if (!this.game.round) return;
  	let backup = this.game.round.saveAnswers();
  	sessionStorage.setItem(
  		`game_${this.game.gameid}_round_${this.game.round.round_id}`,
  		JSON.stringify(backup)
  	)

  	let sessionRounds = sessionStorage.getItem(`game_${this.game.gameid}_rounds`);
  	let rounds = (sessionRounds) ? JSON.parse(sessionRounds) : {};
  	rounds[`r_${this.game.round.round_id}`] = true;
  	sessionStorage.setItem(`game_${this.game.gameid}_rounds`, JSON.stringify(rounds));
  }

  restoreAnswers() {
  	if (!this.game.round) return;
  	let backup = sessionStorage.getItem(`game_${this.game.gameid}_round_${this.game.round.round_id}`)
  	if (backup) {
  		this.game.round.restoreAnswers(JSON.parse(backup));
  	}
  }

  suggest(q_idx: number, a_idx: number, value: string): void {

    if (!this.game.me.is_captain) {
      this.gameService.suggestAnswer(this.game_id, this.game.round_index, q_idx, value)
      .subscribe( (result: any) => {});
    } else {
      console.log("game:", this.game)
      this.game.round.questions[q_idx].answers[a_idx] = value;
      console.log("game after:", this.game)
      this.cdr.markForCheck();
    }
  }

  trackSuggestionText(index: number, obj: any): any {
    return obj.text;
  }

  toggleMenu(menu: string = "menuPosition"): void {
    if (this[menu] === 'show') {
    	this[menu] = 'hide';
    	if (menu === "menuPosition" && this.isLoggedIn && !this.game.my_team.kt_team_id) {
    		sessionStorage.setItem('dismissed_team_register', 'yes')
    	}
    }
    else this[menu] = 'show'
  }

  toggleDouble(): void {
    if (!this.game.me.is_captain) return;
    else if (this.game && this.game.round) {
      this.game.round.doubled = !this.game.round.doubled;
      this.gameService.toggleDouble(this.game.gameid, this.game.round_index, this.game.round.doubled)
        .subscribe((res: any) => {},
          err => {
            this.game.round.doubled = !this.game.round.doubled;
          })
    }
  }
}
